(function() {
  "use strict";

    angular.module("eSign")
    .directive('fileSelect', ['$parse', 'appConfig', function ($parse, appConfig) {
      return {
        restrict: 'E',
        replace: 'true',
        templateUrl: 'templates/FileUpload.html',
        link: function(scope, element, attrs) {

          var inputElem = element[0].querySelector('.input-file');
          scope.allowedFiles = appConfig.allowedFiles;

          scope.clear = function() {
              scope.fsModel = null;
              inputElem.value = "";
          };

          scope.clearErrorMessage = function() {
            scope.errorMessage = "";
          }

          element.bind('change', function (changeEvent) {
            var files = element[0].querySelector('.input-file').files;
            for(var i = 0; i < files.length; i++) {
                var file = files[i];

                if(scope.allowedFiles.split(',').indexOf(file.type) < 0) {
                  scope.errorMessage = "Ugyldig filtype. Aksepterte filtyper er " + appConfig.allowedFileEndings;
                  scope.clear();
                  return;
                }

                if(file.size > 4049600) { // 4mb
                scope.errorMessage = "Filen " + file.name + " er for stor, maks størrelse er 4 MB.";
                scope.clear();
                return;
                }
            }
          });
        },
        scope: {
          fsName: "@",
          fsModel: "="
        }
      }
    }]);
}());
